import dio, { DioContext, DioType } from 'utils/dio/init';

export default {
  subscribeBannerView() {
    dio.track(
      'subscribe_now_bar_button_view',
      DioType.PAGEVIEW,
      {},
      DioContext.LOCKED_FLOW
    );
  },
  subscribeBannerClickSubscribe(pathname: string) {
    dio.track(
      'subscribe_now_bar_button_click',
      DioType.CLICK,
      { location: pathname },
      DioContext.LOCKED_FLOW
    );
  },
  endOfTrialPopUpView(data: any, inTrial: boolean) {
    const event = inTrial ? 'end_of_trial_popup_view' : 'suspended_popup_view';
    dio.track(event, DioType.PAGEVIEW, data, DioContext.LOCKED_FLOW);
  },
  endOfTrialPopUpClickX() {
    dio.track(
      'end_of_trial_popup_click_x',
      DioType.CLICK,
      {},
      DioContext.LOCKED_FLOW
    );
  },
  endOfTrialPopUpClickSubscribe(period: string, inTrial: boolean) {
    const event = inTrial
      ? 'end_of_trial_popup_click_subscribe'
      : 'suspended_popup_click_subscribe';
    dio.track(event, DioType.CLICK, { period }, DioContext.LOCKED_FLOW);
  },
  endOfTrialPopUpConnectAirbnb() {
    dio.track(
      'end_of_trial_popup_click_connect_airbnb',
      DioType.CLICK,
      {},
      DioContext.LOCKED_FLOW
    );
  },
};
